import { useLifecyclePersistence, useSyncLifecycleToExistingAtom } from '../../utilities'
import {
	ExportConfig,
	exportConfigAtom,
	exportConfigSavingAtom,
	exportConfigStatusAtom,
	useExportConfigListener,
} from '../state'

export type UseExportConfigArguments = {
	exportConfig: ExportConfig | undefined
	isPending: boolean
	isSaving: boolean
	onExportConfigChange: (config: ExportConfig) => void
}

export function useExportConfig({
	exportConfig,
	isPending,
	isSaving,
	onExportConfigChange,
}: UseExportConfigArguments) {
	const exportConfigLifecycle = useLifecyclePersistence<ExportConfig>({
		data: exportConfig ?? undefined,
		isIdle: (d) => d == undefined,
		isPending: () => isPending,
		isGenerating: () => false, // Export config doesn't have a generating state
		save: async (configData) => {
			await onExportConfigChange(configData)
		},
		debounceMs: 500,
		debug: false,
		name: 'useExportConfig',
	})

	useSyncLifecycleToExistingAtom(
		exportConfigLifecycle,
		{
			dataAtom: exportConfigAtom,
			useDataListener: useExportConfigListener,
			lifecycleAtom: exportConfigStatusAtom,
			persistenceAtom: exportConfigSavingAtom,
		},
	)

	return {
		isSaving,
		flush: exportConfigLifecycle.flush,
	}
}
